<div
  class="animate-fade-in fixed inset-0 z-50 flex items-center justify-center bg-overlay"
  [class]="fullScreenOnMobile() ? 'p-0 sm:p-4' : 'p-4'">
  <div
    #panel
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="title() ? titleId : null"
    [attr.aria-describedby]="subtitle() ? subtitleId : null"
    class="animate-toast-in w-full overflow-y-auto overscroll-contain bg-background px-6 pb-6 shadow-overlay outline-none"
    [class]="panelClasses()">
    <div class="sticky top-0 z-10 -mx-6 mb-2 flex items-start justify-between gap-4 bg-background pt-5 pr-5 pb-2 pl-6">
      @if (title() || subtitle()) {
        <div class="min-w-0">
          @if (title()) {
            <h2 [id]="titleId" class="text-lg leading-6.5 font-semibold tracking-[-0.01em] text-primary">{{ title() }}</h2>
          }
          @if (subtitle()) {
            <p [id]="subtitleId" class="mt-0.5 text-caption text-secondary">{{ subtitle() }}</p>
          }
        </div>
      }
      <button
        type="button"
        (click)="close()"
        class="touch-hit relative ml-auto flex h-control-sm w-control-sm shrink-0 items-center justify-center rounded-sm text-secondary transition-nike hover:bg-grey-100 hover:text-primary focus-visible:outline-none focus-visible:shadow-focus"
        aria-label="Close">
        <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>

    <ng-content />
  </div>
</div>
